/**
 * 首页
 * Created at 2021-09-28 16:16
 * 真不想寫了，別改需求了，肝不動了
 * @author teapot
 */
import { Carousel, Image } from "antd";
import { Key, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { RootState } from "../../app/store";
import Config from "../../config";
import { homeAsync } from "../../store/HomeStore";
import HomeItem from "./HomeItem";
import HomeItemPhone from "./HomeItemPhone";
import { Button, Modal } from "antd";

import "./index.css";
import show from "./image/show.jpg";

import { useHistory } from "react-router-dom";
import { DetailsParams } from "../../model/HomeModel";
// async gethome(){ await  }
const Home = () => {
  const history = useHistory();

  const { banner, content, content_m, homeNews } = useAppSelector(
    (state: RootState) => state.home
  );
  let contentpro = new Array(3);
  console.log(homeNews);

  const [isModalOpen, setIsModalOpen] = useState(true);
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(homeAsync());
  }, [dispatch]);
  return (
    <div className="home">
      <Carousel autoplay autoplaySpeed={5000}>
        {banner &&
          banner.map((item, index) => {
            return (
              <Image
                src={`${Config.MAIN_URL}${item}`}
                alt={item + ""}
                preview={false}
                key={index}
                width={"100%"}
              />
            );
          })}
      </Carousel>

      <div className="ggs">
        <div className="mostnew">
          {" "}
          {localStorage.getItem("i18nextLng") === "zh-HK"
            ? "最新資訊"
            : "最新资讯"}
        </div>
        {homeNews &&
          homeNews.map((item: any, index: any) => {
            return (
              <div className="newitem-right-item ">
                <div className="news-time"> {item.time}</div>
                <div className="news-title"> {item.category}</div>

                <div
                  className="tinktank-item-middle-content tinktank-item-middle-content-phone news-height"
                  onClick={() => {
                    {
                      history.push(item.uroute, {
                        url: item.url,
                        uuid: item.uuid,
                        methods: "get",
                        pdf: item.pdf,
                        info: item.info,
                        memberName: item.category,
                        education: item.education,
                        position: item.position,
                        memberImg: item.img,
                        video: item.video,
                        newstime: item.time,
                      } as DetailsParams);
                    }
                  }}
                >
                  {item.title}
                  {/* {value.pdf &&pathname=='/newsroom/media-report'? <a href={`${Config.MAIN_URL}${value.pdf}`}>{value.article}</a>:value.article } */}
                </div>
                {/* <div className='news-icons'
              
              > 
              <Image className="imgxia" preview={false} src={share} width={'31px'} />
              </div> */}
                {/* {item.pdf ?  <div className='newx-shell'><div className='pdfload' onClick={()=>{window.location.href=`${Config.MAIN_URL}${item.pdf}`}}> {localStorage.getItem("i18nextLng") === 'zh-HK' ? '下載PDF' : '下载PDF'}</div> <a className='media-icon' href={`${Config.MAIN_URL}${item.pdf}`}></a> <div className='ston'/> </div> : null} */}
              </div>
            );
          })}
      </div>
      <div className="home-pc">
        {content.map((item, index) => {
          return <HomeItem key={index} props={item} />;
        })}
      </div>

      <div className="home-phone">
        {content_m.map((item, index) => {
          return <HomeItemPhone key={index} props={item} />;
        })}
      </div>

      {/* <Modal title="Basic Modal" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}> */}

    </div>
  );
};

export default Home;
